import { useEffect, useState } from 'react';
import { translateDeep } from './translateService';
import { getManualArabic } from './manualAr';
import { useLanguage } from './LanguageContext';

const isBadString = (value) => {
  if (typeof value !== 'string') return false;
  const upper = value.toUpperCase();
  return (
    upper.includes('MYMEMORY WARNING')
    || upper.includes('USAGELIMITS')
    || upper.includes('NEXT AVAILABLE IN')
  );
};

const sanitizeValue = (original, value) => {
  if (value == null) return value;
  if (typeof value === 'string') {
    return isBadString(value) ? original : value;
  }
  if (Array.isArray(value) && Array.isArray(original)) {
    return value.map((item, index) => sanitizeValue(original[index], item));
  }
  if (typeof value === 'object' && typeof original === 'object') {
    const output = { ...value };
    Object.keys(original).forEach((key) => {
      output[key] = sanitizeValue(original[key], output[key]);
    });
    return output;
  }
  return value;
};

const translateManualDeep = (value, key = '') => {
  if (value == null) return value;

  if (typeof value === 'string') {
    const manual = getManualArabic(value.trim());
    return manual || value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => translateManualDeep(item, key));
  }

  if (typeof value === 'object') {
    const output = {};
    Object.entries(value).forEach(([entryKey, entryValue]) => {
      output[entryKey] = translateManualDeep(entryValue, entryKey);
    });
    return output;
  }

  return value;
};

export const useLocalizedStatic = (value) => {
  const { locale, revision } = useLanguage();
  const [localized, setLocalized] = useState(value);

  useEffect(() => {
    let active = true;

    if (locale === 'en') {
      setLocalized(value);
      return () => {
        active = false;
      };
    }

    const manualOnly = translateManualDeep(value);
    if (active) setLocalized(manualOnly);

    translateDeep(value).then((result) => {
      if (active) setLocalized(sanitizeValue(value, result));
    });

    return () => {
      active = false;
    };
  }, [value, locale, revision]);

  return localized;
};

